import React from "react";

function Footer(){
    return(
        <>
        <div className="footer">
        <p>Developer : Ganesh Bodakhe </p>
        </div>
        </>
    )

}
export default Footer;